module.exports = __webpack_public_path__ + "img/materialMechanics_sign.8ed0d988.png";